import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        needsQueryForm: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/tableview',
      name: 'tableview',
      component: () => import(/* webpackChunkName: "tableview" */ './views/TableView.vue'),
      meta: {
        needsQueryForm: true
      }
    },
    {
      path: '/csv',
      name: 'csv',
      component: () => import(/* webpackChunkName: "csvexport" */ './views/CSV.vue'),
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/graphview',
      name: 'graphview',
      component: () => import(/* webpackChunkName: "graphview" */ './views/GraphView.vue'),
      meta: {
        needsQueryForm: true
      }
    },
    {
      path: '/commands',
      name: 'commands',
      component: () => import(/* webpackChunkName: "commands" */ './views/Commands.vue'),
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/managedevices',
      name: 'managedevices',
      component: () => import(/* webpackChunkName: "managedevices" */ './views/ManageDevices.vue'),
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/manageusers',
      name: 'manageusers',
      component: () => import(/* webpackChunkName: "manageusers" */ './views/ManageUsers.vue'),
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ './views/Account.vue'),
      meta: {
        needsQueryForm: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: {
        needsQueryForm: false
      }
    }
  ]
})
